<template>
    <div id="app" class="layout_def">
        <router-view />
    </div>
</template>
<script>
export default {
    name: "App",
    created() {},
};
</script>

<style lang="less">
html{min-height:100%;}
body,
.layout_def {
    min-height: 100%;
}
.layout_def {
    max-width: 750px;
    margin: 0 auto;
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
fieldset,
input,
textarea,
p,
blockquote,
th,
td {
    margin: 0;
    padding: 0;
}
body {
    font-size: 14px;
    font-family: "PingFangSC-Regular", "PingFang SC", sans-serif, "Microsoft YaHei", Helvetica, Tahoma, sans-serif;
    color: #333;
    background: #f7f7f7;
    -webkit-text-size-adjust: none;
}
h1,
h2,
h3,
h4,
h5,
h6,
em {
    font-weight: normal;
    font-size: inherit;
    line-height: normal;
}
ol,
ul {
    list-style: none;
}
input,
img,
select {
    vertical-align: middle;
}
img,
fieldset {
    border: 0;
}
em,
address,
i {
    font-style: normal;
}
textarea {
    resize: none;
}
input,
textarea {
    font-size: inherit;
    -webkit-appearance: none;
    color: inherit;
}
input[type="submit"],
input[type="button"] {
    -webkit-appearance: none;
}
input {
    text-indent: 10px;
    border: none;
    outline: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*ios android去除自带阴影的样式*/
}
a {
    cursor: pointer;
    color: inherit;
    text-decoration: none;
    font-size: inherit;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*ios android去除自带阴影的样式*/
}

.line1 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.line2 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.line3 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}

.label0 {
    padding: 4px;
    background: #ffffff;
    border: 1px solid #ff463c;
    border-radius: 6px;
    font-size: 20px;
    color: #ff463c;
    line-height: 20px;
}
.label1 {
    padding: 4px;
    background: #ff463c;
    border: 1px solid #ff463c;
    border-left: 0;
    border-right: 0;
    border-radius: 6px;
    font-size: 20px;
    color: #ffffff;
    line-height: 20px;
}

@font-face {
    font-family: "iconfont";
    src: url("//static.dangdang.com/iconfont3.3.1/iconfont.eot");
    src: url("//static.dangdang.com/iconfont3.3.1/iconfont.eot?#iefix.eot");
    src: url("//static.dangdang.com/iconfont3.3.1/iconfont.eot?#iefix") format("embedded-opentype"), url("//static.dangdang.com/iconfont3.3.1/iconfont.woff") format("woff"), url("//static.dangdang.com/iconfont3.3.1/iconfont.ttf") format("truetype");
}

.iconfont {
    font-family: "iconfont" !important;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    -moz-osx-font-smoothing: grayscale;
}
</style>
